import React, { useState, useEffect, useContext } from 'react';
import { FirmwareContext } from "../../context/FirmwareContext";
import List from "../../components/list/List";
import './brands.css';
import Button from "../../components/button/Button";

const Brands = () => {
  const firmwares = useContext(FirmwareContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (firmwares && firmwares.length > 0) {
      setLoading(false);
    }
  }, [firmwares]);

  if (loading) {
    return <div className="brands-container">
        <Button route={`/`} text="Atrás" />
        <div className="loading-container">
          <p className='loading'>Cargando Firmwares... Esto puede demorar hasta un minuto, por favor, espere.</p>
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
      </div>;
  }

  if (!firmwares || firmwares.length === 0) {
    return <div className="brands-container"><p className='loading'>No hay datos disponibles.</p></div>;
  }

  const listBrands = [...new Set(firmwares.map(fw => fw.brand))].sort((a, b) => a.localeCompare(b));

  const brandItems = listBrands.map((brand) => {
    const brandFirmware = firmwares.filter(fw => fw.brand === brand);
    
    return {
      label: brand,
      firmwareData: brandFirmware,
      to: `/brands/${brand}`,
    }
  })

  return (
      <div className='brands-container'>
        <Button route={`/`} text="Atrás" />
        <div className="brands-card">
          <h1 className="brands-title">Lista de Marcas</h1>
          <List items={brandItems} />
        </div>
      </div>
  );
};

export default Brands;
